import { CircularProgress } from "@mui/material";

import type { ParameterTimeSeriesConfiguration, ParametersLocation } from "@/lib/api";
import { TimeSeriesConfig } from "@/components/graph/graph.types";
import { DimensionValue } from "@/lib/dimensions";
import { TabsContent } from "@/features/widget-forms/forms/weather-model-map/components/tabs";
import TimeseriesTable from "@/features/dashboard/components/timeseries/timeseries-table";
import TimeseriesGraphs from "@/features/dashboard/components/timeseries/timeseries-graphs";
import ScrollArea from "@/components/scroll-area/scroll-area";
import Stack from "@/components/stack/stack";
import Spacing from "@/components/spacing/spacing";

import { useStationTimeseriesChartData } from "./use-station-timeseries-chart-data";

type StationTimeseriesPanelContentProps = {
  location: ParametersLocation;
  timeSeriesConfigs: TimeSeriesConfig[];
  timeSeriesConfigurations: ParameterTimeSeriesConfiguration[];
  currentTime: DimensionValue;
};

export function StationTimeseriesPanelContent({
  location,
  timeSeriesConfigs,
  timeSeriesConfigurations,
  currentTime,
}: StationTimeseriesPanelContentProps) {
  const { chartData, chartResults, pending } = useStationTimeseriesChartData({
    location,
    timeSeriesConfigs,
    timeSeriesConfigurations,
  });

  if (pending) {
    return (
      <Stack alignItems="center" justifyContent="center">
        <Spacing top={4}>
          <CircularProgress size={24} color="inherit" />
        </Spacing>
      </Stack>
    );
  }

  return (
    <ScrollArea viewportProps={{ style: { maxHeight: "calc(100cqh - 194px)" } }}>
      <TabsContent value="graphs">
        <TimeseriesGraphs
          timeSeriesConfigs={timeSeriesConfigs}
          data={chartData}
          currentTime={currentTime}
        />
      </TabsContent>
      <TabsContent value="table">
        <TimeseriesTable data={chartResults} timeSeriesConfigs={timeSeriesConfigs} />
      </TabsContent>
    </ScrollArea>
  );
}
